import AxiosInstance from '../../config/AxiosInstance';
import AxiosInstanceFormData from '../../config/AxiosInstanceFormData';

const getUserInfor = async (token: string, language: any, userId: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/users/getUserByToken');
        return { data };
    } catch (error) {
        throw error;
    }
};
const getLanguage = async (language: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/users/getLanguage', {
            params: {
                language: language
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};
const updateLanguage = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/users/update-language', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};
const getInforUser = async (userId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/users/' + userId);
        return { data };
    } catch (error) {
        throw error;
    }
};
const updateInforUser = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/users/updateUser', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};
const uploadFile = async (payload: any) => {
    try {
        const { data } = await AxiosInstanceFormData.post('/api/finex/files/upload', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};
const getListReports = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/reports');
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailReports = async (id: string, page: any, limit: any, dateFrom: any, dateTo: any, locationId: any, txnType: any, movementType: any, productId: any, deviceId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/reports/' + id, {
            params: {
                page: page,
                limit: limit,
                date_from: dateFrom,
                location_id: locationId,
                date_to: dateTo,
                txn_type: txnType,
                movement_type: movementType,
                product_id: productId,
                device_id: deviceId,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}
const getListProduct = async (page: any, limit: any, searchValue: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/products/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}
const getListDevice = async (page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/devices/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}
const updateCurrentActive = async (id: string) => {
    try {
        const { data } = await AxiosInstance.put('/api/location/updateCurrentActive/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListCompany = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/user-company/list');
        return { data };
    } catch (error) {
        throw error;
    }
};

const checkSession = async (sessionId: string) => {
    try {
        const { data } = await AxiosInstance.post('/api/users/checkUserSession', { sessionId });
        return { data };
    } catch (error) {
        throw error;
    }
};

export {
    getListDevice,
    getListProduct,
    getUserInfor,
    updateCurrentActive,
    getListCompany,
    checkSession,
    getInforUser,
    updateInforUser,
    uploadFile,
    getLanguage,
    updateLanguage,
    getListReports,
    getDetailReports
}